import React from 'react'
import { UserCheck, List, BarChart2 } from 'react-feather'

export default function VerticalAttendees() {
    const array = [
        {
            id: 'checking',
            title: 'ASISTENTES',
            icon: <UserCheck size={20} />,
            navLink: '/attendees/checkin'
        },
        {
            id: 'list',
            title: 'LISTADO',
            icon: <List size={20} />,
            navLink: '/attendees/list'
        },
        {
            id: 'statistics',
            title: 'ESTADISTICAS',
            icon: <BarChart2 size={20} />,
            navLink: '/attendees/statistics'
        },
    ]

    return array;
}
